module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "regular-reservation"
  }, [_c('div', {
    staticClass: "reservation-heading"
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.status))])]), _vm._v(" "), _c('div', {
    staticClass: "reservation-form"
  }, [_c('div', {
    staticClass: "form-column"
  }, [_c('label', [_vm._v("Golf club"), _c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.golfClub
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Reservation no."), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.number),
      expression: "form.number"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "number", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("No. of holes"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.holes),
      expression: "form.holes"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "holes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("18")]), _c('option', [_vm._v("9")])])]), _vm._v(" "), _c('label', {
    staticClass: "member-search"
  }, [_c('span', [_vm._v("As a member"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.asMember),
      expression: "form.asMember"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.asMember) ? _vm._i(_vm.form.asMember, null) > -1 : (_vm.form.asMember)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.asMember,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "asMember", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "asMember", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "asMember", $$c)
        }
      }
    }
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.search),
      expression: "form.search"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Search member"
    },
    domProps: {
      "value": (_vm.form.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "search", $event.target.value)
      }
    }
  }), _c('button', {
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...")])]), _vm._v(" "), _c('label', [_vm._v("Member ID"), _c('div', {
    staticClass: "input-button"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.memberId),
      expression: "form.memberId"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.memberId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "memberId", $event.target.value)
      }
    }
  }), _c('button', {
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...")])])]), _vm._v(" "), _c('label', [_vm._v("Reservation by"), _c('div', {
    staticClass: "input-button"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.salutation),
      expression: "form.salutation"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "salutation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Mr.")]), _c('option', [_vm._v("Mrs.")])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.reservationBy),
      expression: "form.reservationBy"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.reservationBy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "reservationBy", $event.target.value)
      }
    }
  }), _c('button', {
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...")])])]), _vm._v(" "), _c('label', [_vm._v("Address"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.address),
      expression: "form.address"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("E-mail"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Primary SOB"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.primarySob),
      expression: "form.primarySob"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "primarySob", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("IND - INDIVIDUAL")]), _c('option', [_vm._v("COR - CORPORATE")])])]), _vm._v(" "), _c('label', [_vm._v("Tertiary SOB"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.tertiarySob),
      expression: "form.tertiarySob"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "tertiarySob", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option'), _c('option', [_vm._v("MEMBER")])])]), _vm._v(" "), _c('label', {
    staticClass: "note"
  }, [_vm._v("Note"), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.note),
      expression: "form.note"
    }],
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.form.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "note", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Event"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.event),
      expression: "form.event"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.event)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "event", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-column"
  }, [_c('label', [_vm._v("Booking date"), _c('input', {
    attrs: {
      "type": "date",
      "readonly": ""
    },
    domProps: {
      "value": _vm.bookingDate
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Guest profile ID"), _c('div', {
    staticClass: "input-button"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.guestProfileId),
      expression: "form.guestProfileId"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.guestProfileId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "guestProfileId", $event.target.value)
      }
    }
  }), _c('button', {
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...")])])]), _vm._v(" "), _c('label', [_vm._v("Company ID"), _c('div', {
    staticClass: "input-button"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.companyId),
      expression: "form.companyId"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.companyId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "companyId", $event.target.value)
      }
    }
  }), _c('button', {
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...")])])]), _vm._v(" "), _c('label', [_vm._v("Card ID"), _c('div', {
    staticClass: "input-button"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.cardId),
      expression: "form.cardId"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.cardId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "cardId", $event.target.value)
      }
    }
  }), _c('button', {
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...")])])]), _vm._v(" "), _c('label', [_vm._v("Card no."), _c('div', {
    staticClass: "input-button"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.cardNo),
      expression: "form.cardNo"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.cardNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "cardNo", $event.target.value)
      }
    }
  }), _c('button', {
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...")])])]), _vm._v(" "), _c('label', [_vm._v("Secondary SOB"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.secondarySob),
      expression: "form.secondarySob"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "secondarySob", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("RSV - RESERVATION")]), _c('option', [_vm._v("WIG - WALK IN GUEST")])])]), _vm._v(" "), _c('label', [_vm._v("Market segment"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.marketSegment),
      expression: "form.marketSegment"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "marketSegment", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("INDIVIDUAL")]), _c('option', [_vm._v("CORPORATE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-column"
  }, [_c('label', [_vm._v("Reservation type"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.type),
      expression: "form.type"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.type)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "type", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Status"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.status)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "status", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Company name"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.companyName),
      expression: "form.companyName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "companyName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Mobile no."), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.mobileNo),
      expression: "form.mobileNo"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.mobileNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "mobileNo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Phone no."), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.phoneNo),
      expression: "form.phoneNo"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.phoneNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "phoneNo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("No. of players"), _c('input', {
    attrs: {
      "type": "number",
      "readonly": ""
    },
    domProps: {
      "value": _vm.players.length
    }
  })]), _vm._v(" "), _c('label', [_vm._v("No. of members"), _c('input', {
    attrs: {
      "type": "number",
      "readonly": ""
    },
    domProps: {
      "value": _vm.memberCount
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "caddy-request"
  }, [_c('span', [_vm._v("Caddy request per flight")]), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.caddy),
      expression: "form.caddy"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.caddy) ? _vm._i(_vm.form.caddy, null) > -1 : (_vm.form.caddy)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.caddy,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "caddy", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "caddy", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "caddy", $$c)
        }
      }
    }
  }), _vm._v(" With caddy")])]), _vm._v(" "), _c('label', [_vm._v("Deposit"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.deposit),
      expression: "form.deposit"
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.form.deposit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "deposit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Sales contact"), _c('div', {
    staticClass: "input-button"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.salesContact),
      expression: "form.salesContact"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.salesContact)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "salesContact", $event.target.value)
      }
    }
  }), _c('button', {
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "audit-row"
  }, [_c('span', [_vm._v("Updated by   " + _vm._s(_vm.form.updatedBy))]), _c('span', [_vm._v("Created by   " + _vm._s(_vm.form.createdBy))])]), _vm._v(" "), _c('div', {
    staticClass: "reservation-actions"
  }, [_c('div', [_c('button', {
    staticClass: "btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('back')
      }
    }
  }, [_vm._v("Edit")]), _c('button', {
    staticClass: "btn-secondary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Delete")]), _c('button', {
    staticClass: "btn-secondary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel reservation")])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.form.status = 'Reserved'
      }
    }
  }, [_vm._v("Save")]), _c('button', {
    staticClass: "btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('back')
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-tabs"
  }, [_c('button', {
    class: {
      active: _vm.detailTab === 'flight'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.detailTab = 'flight'
      }
    }
  }, [_vm._v("Flight List")]), _c('button', {
    class: {
      active: _vm.detailTab === 'player'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.detailTab = 'player'
      }
    }
  }, [_vm._v("Player List")])]), _vm._v(" "), (_vm.detailTab === 'flight') ? _c('div', {
    staticClass: "detail-table"
  }, [_vm._m(1), _vm._v(" "), (_vm.players.length) ? _c('div', {
    staticClass: "flight-row"
  }, [_c('span', [_vm._v(_vm._s(_vm.reservation.teeBox))]), _c('span', [_vm._v(_vm._s(_vm.reservation.time))]), _c('span', [_vm._v(_vm._s(_vm.players.length))]), _c('span', [_vm._v("0")]), _c('span', [_vm._v("0")]), _c('span', [_vm._v(_vm._s(_vm.form.caddy ? 'With caddy' : '-'))])]) : _c('div', {
    staticClass: "empty-state"
  }, [_vm._v("Add player from the calendar to create a flight.")])]) : _c('div', {
    staticClass: "detail-table"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.players), function(player, index) {
    return _c('div', {
      key: player.member + index,
      staticClass: "player-row",
      class: {
        selected: player === _vm.selectedPlayer
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.reservation.teeBox))]), _c('span', [_vm._v(_vm._s(_vm.reservation.time))]), _c('span', [_vm._v(_vm._s(player.name))]), _c('span', [_vm._v("Guest")]), _c('span', [_vm._v(_vm._s(player.member))]), _c('span', [_vm._v(_vm._s(player.status))])])
  }), _vm._v(" "), (!_vm.players.length) ? _c('div', {
    staticClass: "empty-state"
  }, [_vm._v("Choose a player from the calendar to display the player list.")]) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("GOLF RESERVATION")]), _c('h3', [_vm._v("Regular Reservation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flight-head"
  }, [_c('span', [_vm._v("Course")]), _c('span', [_vm._v("Tee time")]), _c('span', [_vm._v("No. of player")]), _c('span', [_vm._v("No. of check in")]), _c('span', [_vm._v("No. of check out")]), _c('span', [_vm._v("Caddy request")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "player-head"
  }, [_c('span', [_vm._v("Course")]), _c('span', [_vm._v("Tee time")]), _c('span', [_vm._v("Player name")]), _c('span', [_vm._v("Type")]), _c('span', [_vm._v("Member ID")]), _c('span', [_vm._v("Status")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19f83908"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Golf/RegulerReservation.vue
// module id = 743
// module chunks = 1